import { PayloadAction } from "@reduxjs/toolkit";

import { MyFleetState } from "../../types";

export const setFilter = (
  state: MyFleetState,
  action: PayloadAction<MyFleetState["filter"]>
) => {
  state.filter = action.payload;
};
